<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="employees"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printHandle"> 打印 </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.employeeNO" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入姓名" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <employee-edit ref="employeeEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import EmployeeEdit from "./EmployeeEdit";
  export default {
    components: { viewTable, EmployeeEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(119),
          editAuth: this.$auth(120),
          delAuth: this.$auth(121),
          printAuth: this.$auth(694),
        },
        selection: [],
        filter: {
          employeeNO: "",
          employeeName: "",
        },
        columnsProperty: [
          {
            key: "employeeNO",
            align: "center",
            width: 120,
          },
          {
            key: "employeeName",
            align: "center",
            width: 120,
          },
          {
            key: "genderName",
            align: "center",
            width: 80,
          },
          {
            key: "departmentName",
            minWidth: 160,
          },
          {
            key: "postName",
            width: 160,
          },
          {
            key: "outerNo",
            width: 140,
            align: "center",
          },
          {
            key: "telephone",
            width: 140,
            align: "center",
          },
          {
            key: "mobile",
            width: 140,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.employeeEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "employees", row.employeeID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      printHandle() {
        if (!this.selection.length) {
          this.$confirm("请选择数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const routeUrl = this.$router.resolve({
          path: "/employeePrint",
          query: {
            params: JSON.stringify(this.selection),
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
